let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("iBlXg")).then(() => parcelRequire('dU9yy'));